import { Component, ElementRef, ViewChild, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { IWeather } from '@shared/models/interfaces/IWeather';
import { WeatherService } from '../../../shared/services/weather.service';
import { SidenavComponent } from '../../sidenav.component';

@Component({
  selector: 'app-weather',
  templateUrl: './weather.component.html',
  styleUrls: ['./weather.component.scss']
})
export class WeatherComponent implements OnInit {
  loading: boolean;

  list: IWeather[];
  control: FormControl = new FormControl();
  
  @ViewChild('container') container: ElementRef;
  @ViewChild('provider') provider: ElementRef;

  @Input() sidenav: SidenavComponent;

  constructor(
    private service: WeatherService,
  ) { }

  ngOnInit(): void {
    this.list = this.service.list();
    this.control.valueChanges.subscribe((weather) => this.load(weather));
  }

  load(weather: IWeather) {
    this.loading = true;

    var container: HTMLElement = this.container.nativeElement;
    var provider: HTMLElement = this.provider.nativeElement;

    provider.setAttribute('href', weather.forecast);
    provider.setAttribute('data-label_1', weather.place);
    provider.setAttribute('style', '');

    if (container.children.length > 1) {
      provider.removeChild(provider.firstChild);
      container.removeChild(container.lastChild);
    }

    var script = document.createElement('script');

    script.id = 'weatherwidget-io-js';
    script.src = 'https://weatherwidget.io/js/widget.min.js';

    container.appendChild(script);

    setTimeout(() => this.loading = false, 2000);
  }
}
